// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0351e3f1","616":"0040e40d"}[chunkId] + ".chunk.js";
};